// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2LEIW","modalBody":"modalBody--1dvem","btnWrapper":"btnWrapper--2WUuJ","submitBtn":"submitBtn--zlb0Q","title":"title--1b9In"};